import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import {
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { StatusChip } from "@akj-dev/shared-components";
import { FileDrop } from "../../../../shared/components/File/Drop";
import { StatusLarge } from "../../../../shared/components/StatusLarge";
import { listDocuments } from "../../../../store/order/actions";
import { useDispatch, useSelector } from "react-redux";
import { ParsableDate } from "typings";

interface ContentProps {
  files: any[];
  uploadSending: boolean;
  uploadResponse: Record<string, any>;
  onChangeMeta: (propertyName: string, value: ParsableDate[] | File[]) => void;
  onUploadDocuments: () => void;
  onResetUploadStatus: () => void;
  closeDialog: () => void;
}

export const UploadSupportingDocumentsContent = ({
  closeDialog,
  onChangeMeta,
  onUploadDocuments,
  onResetUploadStatus,
  files,
  uploadResponse,
  uploadSending,
}: ContentProps) => {
  const dispatch = useDispatch();
  const getListDocuments = useSelector(
    (state: any) => state.order.listDocuments.response
  );
  useEffect(() => {
    dispatch(listDocuments());
  }, [dispatch, uploadResponse]);
  return (
    <>
      <DialogContent>
        <Box>
          {getListDocuments.data &&
            getListDocuments.data.documents.map((document: any) => (
              <Box mb={1}>
                <StatusChip
                  type="success"
                  title="File uploaded"
                  message={document.filename}
                />
              </Box>
            ))}
        </Box>
        {uploadSending || uploadResponse ? (
          <div className="u-text-center">
            {uploadSending && (
              <Box
                m={4}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <Box mb={4}>
                  <CircularProgress size={80} />
                </Box>
                <Typography variant="h5">Uploading Documents</Typography>
              </Box>
            )}
            {uploadResponse && (
              <div>
                {uploadResponse.status === "success" ? (
                  <StatusLarge type="success" title="Success" />
                ) : (
                  <StatusLarge
                    type="error"
                    title="Sorry, something went wrong."
                    message={uploadResponse.message}
                  />
                )}
              </div>
            )}
          </div>
        ) : (
          <Box my={2}>
            <Grid container spacing={2}>
              <Grid item sm={12}>
                {files ? (
                  files.map((file: File) => (
                    <Box mb={1}>
                      <StatusChip title="File selected" message={file.name} />
                    </Box>
                  ))
                ) : (
                  <FileDrop
                    onDrop={(files) => onChangeMeta("files", files)}
                    message="Drag supporting documents here"
                    maxSize={3e7}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        {uploadResponse.status === "success" ? (
          <Button variant="contained" onClick={closeDialog}>
            Close
          </Button>
        ) : (
          <Button
            variant="contained"
            key="cancel"
            onClick={closeDialog}
            disabled={uploadSending}
            style={{ marginRight: 10 }}
          >
            Cancel
          </Button>
        )}

        {uploadResponse ? (
          <Button
            variant="contained"
            color="primary"
            key="retry"
            onClick={onResetUploadStatus}
            disabled={uploadSending}
          >
            Retry
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            key="upload"
            onClick={onUploadDocuments}
            disabled={uploadSending || !files}
          >
            Upload
          </Button>
        )}
      </DialogActions>
    </>
  );
};
